import { useCallback, useState } from 'react';

import isEqual from 'react-fast-compare';

const updateFormValueFromPath = (currentForm, path, value) => {
  // if there are no other fields, this is a leaf; return the value.
  if (!path?.length) {
    return value;
  }

  const [property, ...restOfPath] = path;
  const previousValue = currentForm?.[property];
  const updatedValue = updateFormValueFromPath(currentForm?.[property] || {}, restOfPath, value);

  // Nothing change, return the same object reference.
  if (isEqual(updatedValue, previousValue)) {
    return currentForm;
  }

  return {
    ...currentForm,
    [property]: updatedValue,
  };
};

export const useForm = (initialForm) => {
  const [form, setForm] = useState(initialForm || {});

  const updateFormState = useCallback(
    (path, value) => {
      setForm((previousFormState) => updateFormValueFromPath(previousFormState, path, value));
    },
    [setForm],
  );

  return { form, updateForm: updateFormState };
};
